(function ($) {
  $(function () {
    var $header = $('header');

    if ($header.length) {
      var navigation = (function () {
        var $header = $('header');
        var $navSearchButton = $('header .search-btn');
        var $searchCloseButton = $('header .search-form .search-close-btn');
        var $navMenu = $('header nav');
        var $navItems = $('header ul.nav-menus > li');
        var navItemsWithDropdown = 'header ul.nav-menus > li.with-dropdown';
        var $innerMenu = $('header ul.nav-menus > li .inner-menu');
        var $innerMenuItem = $('header ul.nav-menus > li .inner-menu-item');
        var $toggleButton = $('header .hamburger-menu');
        var path = window.location.pathname;

        function addActiveClass(url) {
          $('header ul.nav-menus li a[href="' + url + '"]')
            .parents('.with-dropdown')
            .eq(0)
            .addClass('active-menu');
        }

        function searchButton() {
          if ($header.hasClass('search-slide-left')) {
            $header.removeClass('search-slide-left');
          } else {
            $header.addClass('search-slide-left');
          }
        }

        function navScroll() {
          $(window).on('scroll', function () {
            var scroll = $(window).scrollTop();

            if (scroll > 15) {
              $header.addClass('active');
            } else {
              $header.removeClass('active');
            }
          });
        }

        function checkDropdown(navItem, dropdownClass) {
          if (navItem.length) {
            $(navItem).each(function () {
              if ($(this).find('.dropdown-menu').length) {
                $(this).addClass(dropdownClass);
              }
            });
          }
        }

        function dropdownMenuOpen() {
          if ($(navItemsWithDropdown).length) {
            $(navItemsWithDropdown).on({
              mouseenter: function () {
                if ($(window).width() > 991) {
                  $('body').addClass('stop-scroll');

                  $(this)
                    .siblings()
                    .removeClass('active-nav')
                    .find('.dropdown-menu.open')
                    .removeClass('open');
                  $(this).addClass('active-nav').find('.dropdown-menu').addClass('open');
                }
              },
              mouseleave: function () {
                $('body').removeClass('stop-scroll');
                if ($(window).width() > 991) {
                  $(this).removeClass('active-nav').find('.dropdown-menu').removeClass('open');
                }
              },

              click: function (e) {
                if ($(window).width() <= 991) {
                  $('body').toggleClass('stop-scroll');
                  // e.preventDefault();
                  $(this)
                    .siblings()
                    .removeClass('active-nav ')
                    .find('.dropdown-menu.open')
                    .removeClass('open');
                  $(this).toggleClass('active-nav');
                  $(this).find('.dropdown-menu').toggleClass('open');
                  $(this).find('.dropdown-menu .menu-tabs').first().addClass('show');
                }
              },
            });
          }
        }

        function addIdOnInnerMenu() {
          $innerMenu.each(function (i) {
            $(this).attr('data-tab-id', 'tab-' + (i + 1));
          });
          $innerMenuItem.each(function (i) {
            $(this).attr('id', 'tab-' + (i + 1));
          });
        }

        function innerMenuHover() {
          $innerMenu.on('mouseenter', function () {
            var innerMenuId = $(this).attr('data-tab-id');

            $(this).closest('.sub-menu').find('.inner-menu-item').removeClass('active');

            $(this)
              .closest('.sub-menu')
              .find('#' + innerMenuId)
              .addClass('active');
          });

          $innerMenu.on('click', function (e) {
            e.stopPropagation();
            if ($(window).width() >= 767 && $(window).width() <= 991) {
              e.preventDefault();
            }

            if ($(window).width() <= 991) {
              var innerMenuId = $(this).attr('data-tab-id');
              $(this).closest('.sub-menu').find('.inner-menu-item').removeClass('active');

              $(this)
                .closest('.sub-menu')
                .find('#' + innerMenuId)
                .addClass('active');
            }
          });
        }

        function toggleNav() {
          if ($toggleButton.hasClass('active')) {
            $toggleButton.removeClass('active');
            $navMenu.fadeOut().removeClass('mobile-nav-active');
          } else {
            $toggleButton.addClass('active');
            $navMenu.fadeIn().addClass('mobile-nav-active');
          }
        }

        return {
          init: function () {
            $header.removeClass('search-slide-left');

            addActiveClass(path);

            addIdOnInnerMenu();

            navScroll();

            checkDropdown($navItems, 'with-dropdown');

            dropdownMenuOpen();

            // innerMenuHover();

            $navSearchButton.on('click', searchButton);

            $searchCloseButton.on('click', searchButton);

            $toggleButton.on('click', toggleNav);
          },
        };
      })();

      $(navigation.init);

      $('header .search-form').css({ opacity: 1, visibility: 'visible' });
    }
  });
})(jQuery);
